import Vue from 'vue'
import Vuex from 'vuex'
import VueCookies from 'vue-cookies';
import ApiClient from './common/api.js';


Vue.use(Vuex)
Vue.use(VueCookies)

export default new Vuex.Store({
    state: {
        token: null,
        errors: [],
        postParam: {},
        initDetail: false,
        adminData: {},
        userData: {},
    },
    getters: {
        token(state) {
            if (!state.token) {
                if (!VueCookies.get('__jwt_token_admin')) {
                    return '';
                }
                state.token = VueCookies.get('__jwt_token_admin');
            }
            return state.token;
        },
        errors(state) {
            return state.errors;
        },

        getPostParam: (state) => state.postParam,
        getAdminData(state) {
          if (Object.keys(state.adminData).length == 0) {
            if (!VueCookies.get('admin_data')) {
              return {};
            }
            state.adminData = VueCookies.get('admin_data');
          }
          return state.adminData;
        },
        getUserData(state) {
          if (Object.keys(state.userData).length == 0) {
            if (!VueCookies.get('user_data')) {
              return {};
            }
            state.userData = VueCookies.get('user_data');
          }
          return state.userData;
        },
    },
    mutations: {
        initPostParam(state) {
          state.postParam = {};
        },
        setToken(state, token) {
            state.token = token;
            VueCookies.set('__jwt_token_admin', token);
        },
        setDetailParam(state, table) {
            state.postParam = table.detail;
            state.initDetail = true;
        },
        setErrors(state, errors) {
            state.errors = errors;
        },
        setPostParam(state, table) {
            if (table.group != null) {
                if (!state.postParam[table.group]) {
                    state.postParam[table.group] = [];
                }

                if (table.index != null) {
                    if (!state.postParam[table.group][table.index]) {
                        state.postParam[table.group][table.index] = {};
                    }
                    state.postParam[table.group][table.index][table.label] = table.value;
                } else {
                    state.postParam[table.group][table.label] = table.value;
                }
            } else {
                if (table.index != null) {
                    if (!state.postParam[table.label]) {
                        state.postParam[table.label] = [];
                    }
                    state.postParam[table.label][table.index] = table.value;
                } else {
                    state.postParam[table.label] = table.value;
                }
            }
        },
        setAdminData(state, adminData){
            state.adminData = adminData;
            VueCookies.set('admin_data', adminData);
        },
        setUserData(state, userData){
          state.userData = userData;
          VueCookies.set('user_data', userData);
        },

    },
    actions: {
        initPostParam(state) {
          state.commit('initPostParam');
        },
        setToken(state, token) {
            state.commit('setToken', token);
        },
        setErrors(state, errors) {
            state.commit('setErrors', errors);
        },
        setPostParam(state, table) {
            state.commit('setPostParam', table);
        },
        setDetailParam(state, table) {
            state.commit('setDetailParam', table);
        },
        setAdminData(state, adminData) {
            state.commit('setAdminData', adminData);
        },
        setUserData(state, userData) {
          state.commit('setUserData', userData);
        },
    },
    modules: {

    },
})
